export const formularioSlice = (set,get) => ({
    estatus: [{value:1,label:"Activo"},{value:2,label:"Oculto"}],
    handleChange: (e) => set({ datos:{ ...get().datos, [e.target.name]: e.target.value } }),
})